import { useEffect } from "react";

import { useRect } from "~/hooks/useRect";

import type { WatchViewLayoutEvent } from "./WatchView";

export interface WatchViewStagePaneProps {
  children?: React.ReactNode;
  onLayout?: (event: WatchViewLayoutEvent) => void;
}

export function WatchViewStagePane({
  children,
  onLayout,
}: WatchViewStagePaneProps) {
  const [ref, DOMRect] = useRect<HTMLDivElement>();

  useEffect(() => {
    requestAnimationFrame(() => {
      if (ref.current) {
        onLayout?.({ DOMRect, element: ref.current });
      }
    });
  }, [DOMRect, onLayout, ref]);

  return (
    <div ref={ref} className="WatchViewStagePane">
      {children}
    </div>
  );
}
